import React from "react";
import { Link } from "react-router-dom";
import "./style.css";
import elonImg from "../../assets/images/elon_404.png";

const NotFound = () => {
  return (
    <section className="not-found-section">
      <div className="not-found-container">
        <div className="elon-img-wrapper">
          <img
            src={elonImg}
            alt="Elon Musk looking around awkwardly"
            className="elon-img"
          />
        </div>
        
        <div className="content">
          <h1 className="error-code">
            4🚀4
          </h1>
          
          <h2 className="error-title">
            Houston, We Have a Problem!
          </h2>
          
          <p className="error-message">
            The page you're looking for has been launched into space. <br />
            Even Elon can't find it! 🛸
          </p>
          
          <div className="d-flex flex-column flex-sm-row gap-3 justify-center align-items-center">
            <Link to="/" className="btn-earth btn btn-success">
              🏠 Return to Earth
            </Link>
            
            <Link to="/contacts" className="btn-mission-control btn btn-light">
              📡 Contact Mission Control
            </Link>
          </div>
        </div>
        
        <div className="error-footer">
          <p>SYSTEM STATUS: MISSION_LOST_404 // LOCATION: DEEP_SPACE</p>
        </div>
      </div>
    </section>
  );
};

export default NotFound;